
import { Component, Vue } from 'vue-property-decorator'
import DetailDialog from './DetailDialog.vue'
import { ownModelRating, loanStatus, repaymentStatus, isEnsured, isFinished } from '@/utils/dictionary'
import dayjs from 'dayjs'
import http from '@/utils/request'
import { ElForm } from 'element-ui/types/form'
import { createInsuranceTypeList, InsuranceType } from '../bid-details/component/insurance.interface'
import i18n from '@/lang'

@Component({
  components: {
    'app-detail-dialog': DetailDialog
  },
  filters: {
    toInsuranceChannelName(value: number) {
      const types = createInsuranceTypeList()
      const findType = types.find(item => item.value === value);
      return findType && findType.name
    }
  }
})
export default class extends Vue {
  private list: any[] = []
  private listLoading = true
  private listTotal = 0
  private listQuery = {
    page: 1,
    size: 10,
    //
    lendNo: '',
    buyStartTime: '',
    buyEndTime: '',
    idNo: '',
    ownModelRating: '',
    loanBidStatus: '',
    isFinished: '',
    isEnsured: '',
    tradeStartTime: '',
    tradeEndTime: ''
  }

  buyTime = ''
  tradeTime = ''
  importanceOptions = [1, 2, 3]
  showDetail = false
  dialogVisible = false
  src = ''
  currentRowData: any = {}
  ownModelRatingOptions = ownModelRating
  loanStatusOptions = loanStatus
  repaymentStatusOptions = repaymentStatus
  isInsuredOptions = isEnsured
  isFinishedOptions = isFinished
  InsuranceType = InsuranceType

  created() {
    this.getList()
  }

  async getInsurance(list: any[]) {
    const arr = list
    for (let index = 0; index < arr.length; index++) {
      if (arr[index].insuranceUrl) {
        //
      } else {
        // const button = document.getElementById(`polis-${arr[index].loanId}`) as HTMLButtonElement
        // button.disabled = true
        // button.classList.add('el-button--info')
        arr[index].disabled = true
      }
    }
    this.list = arr
  }

  viewPDF(row: any) {
    window.open(row.insuranceUrl, '_blank')
  }

  private async getList() {
    this.listLoading = true
    http.post('/lend/queryLoanBid', this.listQuery).then((data) => {
      this.list = data.records
      this.listTotal = data.total
      if (this.list.length) {
        setTimeout(() => {
          this.getInsurance(this.list)
        }, 50)
      }
    })
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false
    }, 0.5 * 1000)
  }

  handleSizeChange(val: number) {
    this.listQuery.size = val
    this.getList()
  }

  handleCurrentChange(val: number) {
    this.listQuery.page = val
    this.getList()
  }

  view(row: any) {
    this.$router.push({
      path: '/dashboard/bid-details',
      query: { lid: row.loanId, qoalaStatus: row.qoalaStatus, cameraId: row.cameraId }
    })
  }

  pdf1(row: any) {
    const pdfLoading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    http
      .post('/lend/api/queryLendDetail', {
        lid: row.loanId
      })
      .then((response) => {
        // console.log(response)
        if (response.borrowPdf) {
          // this.src = response.borrowPdf
          // this.dialogVisible = true
          window.open(response.borrowPdf, '_blank')
        } else {
          this.$message.warning(i18n.t('Tidak ada perjanjian pinjaman. Silakan ajukan pinjaman terlebih dahulu.') as string)
        }
      })
      .catch(() => {
        /** Cancel action */
      })
      .finally(() => {
        pdfLoading.close()
      })

    // === 20241024
    // http
    //   .post(
    //     '/userDigisign/borrowDigisignPdf',
    //     { loanBusiId: row.loanBusiId, mid: row.mid },
    //     {
    //       responseType: 'blob'
    //     }
    //   )
    //   .then((response) => {
    //     const blob = new Blob([response], { type: 'application/pdf;charset-UTF-8' })
    //     this.src = window.URL.createObjectURL(blob)
    //     this.dialogVisible = true
    //   })
    //   .catch((err) => {

    //   })
  }

  pdf2(row: any) {
    const pdfLoading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading'
    })
    http
      .post(
        '/sign/lendDigisignPdf?tenantId=' + row.tenantId + '&bizId=' + row.cameraId + '&mid=' + row.userNo,
        {
          lendAmount: row.lendAmount,
          loanBusiId: row.loanBusiId,
          qoalaStatus: row.qoalaStatus,
          busiBatchId: row.busiBatchId,
          mid1: row.mid1
        },
        {
          responseType: 'blob'
        }
      )
      .then((response) => {
        // console.log(response.size)
        if (response && response.size > 0) {
          const blob = new Blob([response], { type: 'application/pdf;charset-UTF-8' })
          // this.src = window.URL.createObjectURL(blob)
          // this.dialogVisible = true
          window.open(window.URL.createObjectURL(blob), '_blank')
        } else {

          this.$message.warning(i18n.t('Tidak ada perjanjian pinjaman. Silakan ajukan pinjaman terlebih dahulu.') as string)
        }
      })
      .catch((err) => {

      })
      .finally(() => {
        pdfLoading.close()
      })
  }

  setTradeTime() {
    const [startTime, endTime] = this.tradeTime || []
    if (startTime && endTime) {
      this.listQuery.tradeStartTime = dayjs(startTime).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.listQuery.tradeEndTime = dayjs(endTime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    }
  }

  setBuyTime() {
    const [startTime, endTime] = this.buyTime || []
    if (startTime && endTime) {
      this.listQuery.buyStartTime = dayjs(startTime).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.listQuery.buyEndTime = dayjs(endTime).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    }
  }

  onSearch() {
    this.setTradeTime()
    this.setBuyTime()
    this.getList()
  }

  onReset() {
    /** Cancel action */
    // eslint-disable-next-line
    ;(this.$refs.filtersRef as ElForm).resetFields()
    this.listQuery.tradeStartTime = ''
    this.listQuery.tradeEndTime = ''
    this.listQuery.buyStartTime = ''
    this.listQuery.buyEndTime = ''
    this.buyTime = ''
    this.tradeTime = ''
  }

  //  time clear
  timeChange(value: any, start: 'tradeStartTime' | 'buyStartTime', end: 'tradeEndTime' | 'buyEndTime') {
    if (value === null) {
      this.listQuery[start] = ''
      this.listQuery[end] = ''
    }
  }
}
